






















































import { Component, Prop, Vue } from "vue-property-decorator";
import { ACTION_REMOVE_USER } from "@/store/actions-types";
import { BValidationState } from "@/models/common/BValidationState";

@Component
/**
 * Displays a single delete button and asks for confirmation
 * for a user removal
 */
export default class DeleteUserBtn extends Vue {
  /**
   * The username which will be deleted
   */
  @Prop({ required: true }) readonly username!: string;

  /**
   * Disabled state of the main button
   */
  @Prop({ required: false, default: false }) readonly disabled!: boolean;

  /**
   * indicator if delete confirm modal shows
   */
  public showModal = false;

  /**
   * user must confirm the username that should be deleted
   */
  public usernameConfirm = "";

  /**
   * indicate loading state while deleting
   */
  public isLoading = false;

  /**
   * check form validation state
   */
  get isFormValid(): BValidationState {
    if (this.usernameConfirm === "") {
      return null;
    }
    return this.usernameConfirm === this.username;
  }

  /**
   * toggle modal visibility
   */
  public toggleModal(): void {
    this.showModal = !this.showModal;
  }

  /**
   * remove a user
   */
  async removeUser(username: string): Promise<void> {
    try {
      this.isLoading = true;
      await this.$store.dispatch(ACTION_REMOVE_USER, username);
      this.$emit("user-deleted");
    } finally {
      this.isLoading = false;
    }
  }
}
